var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"title":"工单业务域配置(敬请期待)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }